export default {
    SUBJECT_PAGE: {
        SUBJECT_NAME: {
            en: 'Subject Name:',
            in: 'Nama Mata Pelajaran:'
        },
        ADD_SUBJECT: {
            en: 'Add Subject',
            in: 'Tambah Mata Pelajaran'
        },
        EDIT_SUBJECT: {
            en: 'Edit Subject',
            in: 'Ubah Mata Pelajaran'
        },
        NO_DESCRIPTION: {
            en: 'Click edit to add a short description of this subject.',
            in: 'Klik edit untuk menambahkan deskripsi singkat tentang mata pelajaran ini.'
        },
        LEARNING_ITEMS: {
            en: "What you'll learn",
            in: 'Yang akan kamu pelajari'
        },
        EDIT_LEARNING_ITEMS: {
            en: 'Edit What you\'ll learn',
            in: 'Ubah yang akan kamu pelajari'
        },
        LEARNING_ITEMS_HINT: {
            en: 'Enter one item per line. Paste multiple lines at once.',
            in: 'Masukkan satu item per baris. Tempel beberapa baris sekaligus.'
        },
        LEARNING_ITEMS_EMPTY: {
            en: "Click edit to add what participants will learn.",
            in: 'Klik edit untuk menambahkan apa yang akan dipelajari peserta.'
        },
        DESCRIPTION_TITLE: {
            en: 'Description',
            in: 'Deskripsi'
        },
        EDIT_DESCRIPTION: {
            en: 'Edit Description',
            in: 'Ubah Deskripsi'
        },
        DESCRIPTION_EMPTY: {
            en: 'Click edit to add a description.',
            in: 'Klik edit untuk menambahkan deskripsi.'
        },
        AUDIENCE_TITLE: {
            en: "Who This Course is For",
            in: 'Untuk Siapa Kursus Ini'
        },
        EDIT_AUDIENCE: {
            en: "Edit Who This Course is For",
            in: 'Ubah Untuk Siapa Kursus Ini'
        },
        AUDIENCE_EMPTY: {
            en: "Click edit to add who this course is for.",
            in: 'Klik edit untuk menambahkan untuk siapa kursus ini.'
        },
        REQUIREMENTS_TITLE: {
            en: "Requirements",
            in: 'Persyaratan'
        },
        EDIT_REQUIREMENTS: {
            en: "Edit Requirements",
            in: 'Ubah Persyaratan'
        },
        REQUIREMENTS_EMPTY: {
            en: "Click edit to add requirements.",
            in: 'Klik edit untuk menambahkan persyaratan.'
        },
        LANGUAGE_HINT: {
            en: 'Course language',
            in: 'Bahasa kursus'
        },
        LANGUAGE: {
            en: 'Language',
            in: 'Bahasa'
        },
        LANGUAGE_OPTION_EN: {
            en: 'English',
            in: 'Inggris'
        },
        LANGUAGE_OPTION_IN: {
            en: 'Indonesian',
            in: 'Indonesia'
        },
        DESCRIPTION_LIMIT_ERROR: {
            en: `Description must not exceed ${300} characters.`,
            in: `Deskripsi tidak boleh lebih dari ${300} karakter.`
        },
        SAVED: {
            en: 'Subject has been saved.',
            in: 'Mata pelajaran telah disimpan.'
        },
        UPLOAD_IMAGE: {
            en: 'Upload course image',
            in: 'Unggah gambar kursus'
        },
        UPLOAD_IMAGE_HINT: {
            en: 'Click to upload a course cover image',
            in: 'Klik untuk mengunggah gambar sampul kursus'
        },
        UPLOAD_FAILED: {
            en: 'Upload failed',
            in: 'Gagal mengunggah'
        },
        DELETE_CONFIRM_TITLE: {
            en: 'Delete Subject',
            in: 'Hapus Mata Pelajaran'
        },
        DELETE_CONFIRM_MESSAGE: {
            en: 'Are you sure you want to delete this subject?',
            in: 'Apakah Anda yakin ingin menghapus mata pelajaran ini?'
        },
        DELETED: {
            en: 'Subject has been deleted.',
            in: 'Mata pelajaran telah dihapus.'
        },
        GO_TO_COURSE: {
            en: 'Go to course',
            in: 'Ke kursus'
        },
        QUIZ: {
            en: 'Quiz',
            in: 'Kuis'
        },
        SHOW_MORE: {
            en: 'Show more',
            in: 'Tampilkan lebih'
        },
        SHOW_LESS: {
            en: 'Show less',
            in: 'Tampilkan lebih sedikit'
        },
        COURSE_STRUCTURE: {
            en: 'Course Structure',
            in: 'Struktur Kursus'
        },
        ASSESSMENT_QUIZ: {
            en: 'Assessment / Quiz',
            in: 'Penilaian / Kuis'
        },
        NO_ASSESSMENTS: {
            en: 'No assessments available.',
            in: 'Tidak ada penilaian tersedia.'
        },
        QUIZ_NOT_PUBLISHED: {
            en: 'Quiz is not published yet!',
            in: 'Kuis belum dipublikasikan!'
        },
        COMPLETED: {
            en: 'Completed',
            in: 'Selesai'
        },
        NOT_COMPLETED: {
            en: 'Not Completed',
            in: 'Belum Selesai'
        },
        SELECT_TOPIC: {
            en: 'Select a topic to start learning',
            in: 'Pilih topik untuk mulai belajar'
        },
        SELECT_TOPIC_HINT: {
            en: 'Choose a lesson from the left panel',
            in: 'Pilih pelajaran dari panel kiri'
        }
    }
}